import { useState, useEffect, useCallback } from 'react';
import { adminApi } from '../services/adminApi';
import { AccountsOverviewResponse } from '../types/admin';
import { toUserMessage } from '../lib/apiError';

export function useConnectedAccounts() {
  const [data, setData] = useState<AccountsOverviewResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await adminApi.accounts.getOverview();
      setData(result);
    } catch (err) {
      setError(toUserMessage(err, "We couldn't load the accounts overview. Please try again."));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
